module.exports = __webpack_public_path__ + "static/media/blockquote.c6b6a480.svg";